# frozen_string_literal: true

require_relative '../meta'

module Engine
  module Game
    module G18Norway
      module Meta
        include Game::Meta

        DEV_STAGE = :beta
        PROTOTYPE = true

        GAME_DESIGNER = 'Pontus Nilsson and Arne Kjell Vikhagen'
        GAME_LOCATION = 'Norway'
        GAME_PUBLISHER = :self_published
        GAME_RULES_URL = 'https://github.com/akvik/18Norway/blob/main/18Norway_Rules.pdf'
        GAME_INFO_URL = ''

        PLAYER_RANGE = [3, 5].freeze
        OPTIONAL_RULES = [
          {
            sym: :private_b_companies,
            short_name: 'Use private B companies',
            desc: 'Use side B for private companies P2, P3 and P4',
          },
          {
            sym: :random_private_companies,
            short_name: 'Use random private companies sides',
            desc: 'Randomly choose side A or Bfor P2, P3 and P4',
          },
        ].freeze
      end
    end
  end
end
